
// --------------------------------------------

// -- KV内 画面遷移時のアニメーションを処理

// --------------------------------------------

export default class kvTransition {
    constructor(effect,ease) {

        this.$target;


        this.status = [];
        this.conf = {
            num : 0,
            ease : ease
        }

        this.execution = false;

        this.effect = effect;

     }
    init(pageID,filterID){

        this.$target = document.getElementsByClassName('js__trans');
        this.conf.num = this.$target.length;

        // kv内でアニメーションになっているもののタイプと移動レートを取得
        for(var i=0; this.conf.num>i; i++){
            var $t = this.$target[i];

            this.status[i] = {
                rate : $t.getAttribute('data-rate'),
                type : ""
            }

            let _t;
            for(let j=0; j < $t.classList.length; j++){
                if($t.classList[j].match(/js__dir-/g))  _t = $t.classList[j].replace("js__","");
                this.status[i].type = _t;
            }

        }

        /* TOP以外は一旦全部消す */
        if(pageID!=="top"){

            // let _op = type==="in"?1:0,
            //     _inc = type==="in"?0:window.innerWidth/2;

            /* TOPと下層共通で表示する要素 */
            for(let i=0; this.conf.num>i; i++){
                // if(this.kvPoint[i]===undefined) return;
                let $t = this.$target[i];

                // let _r = type=="out"||type=="in" ? filterID!==$t.getAttribute("data-id"):filterID===$t.getAttribute("data-id");

                this.set($t,i,"",0,window.innerWidth/2);




            }

        }

    }
    /* 画面遷移させる際のKVの動作 */
    motion(filterID,type){

        let _op = type==="in"?1:0,
            _inc = type==="in"?0:window.innerWidth/2;

        /* TOPと下層共通で表示する要素 */
        for(let i=0; this.conf.num>i; i++){
            // if(this.kvPoint[i]===undefined) return;
            let $t = this.$target[i];

            // let _r = type=="out"||type=="in" ? filterID!==$t.getAttribute("data-id"):filterID===$t.getAttribute("data-id");

            if(filterID!==$t.getAttribute("data-id")){
                this.trans($t,i,type,_op,_inc);
            }else{
                this.trans($t,i,type,1,0);
            }




        }

    }
    trans($t,no,type,op,inc){
        switch (this.status[no].type){
            case "dir-y":
                TweenMax.to($t,this.conf.ease[type].speed,{
                    "y":-inc,
                    "opacity":op,
                    "ease":this.conf.ease[type].type
                });
                break;
            case "dir-y-plus":
                TweenMax.to($t,this.conf.ease[type].speed,{
                    "y":inc,
                    "opacity":op,
                    "ease":this.conf.ease[type].type
                });
                break;
            case "dir-x-plus":
                TweenMax.to($t,this.conf.ease[type].speed,{
                    "x":inc,
                    "opacity":op,
                    "ease":this.conf.ease[type].type
                });
            case "dir-xy-minus":
                TweenMax.to($t,this.conf.ease[type].speed,{
                    "x":-inc,
                    "y":-inc,
                    "opacity":op,
                    "ease":this.conf.ease[type].type
                });
                break;
            case "dir-xy-plus":
                TweenMax.to($t,this.conf.ease[type].speed,{
                    "x":inc,
                    "y":inc,
                    "opacity":op,
                    "ease":this.conf.ease[type].type
                });
                break;
            case "dir-x-plus-y-minus":
                TweenMax.to($t,this.conf.ease[type].speed,{
                    "x":inc,
                    "y":-inc,
                    "opacity":op,
                    "ease":this.conf.ease[type].type
                });
                break;
            case "dir-x-minus-y-plus":
                TweenMax.to($t,this.conf.ease[type].speed,{
                    "x":-inc,
                    "y":inc,
                    "opacity":op,
                    "ease":this.conf.ease[type].type
                });
                break;
            default :
                TweenMax.to($t,this.conf.ease[type].speed,{
                    "x":-inc,
                    "opacity":op,
                    "ease":this.conf.ease[type].type
                });
                break;
        }
    }
    set($t,no,type,op,inc){
        switch (this.status[no].type){
            case "dir-y":
                TweenMax.set($t,{
                    "y":-inc,
                    "opacity":op,
                });
                break;
            case "dir-y-plus":
                TweenMax.set($t,{
                    "y":inc,
                    "opacity":op,
                });
                break;
            case "dir-x-plus":
                TweenMax.set($t,{
                    "x":inc,
                    "opacity":op,
                });
            case "dir-xy-minus":
                TweenMax.set($t,{
                    "x":-inc,
                    "y":-inc,
                    "opacity":op,
                });
                break;
            case "dir-xy-plus":
                TweenMax.set($t,{
                    "x":inc,
                    "y":inc,
                    "opacity":op,
                });
                break;
            case "dir-x-plus-y-minus":
                TweenMax.set($t,{
                    "x":inc,
                    "y":-inc,
                    "opacity":op,
                });
                break;
            case "dir-x-minus-y-plus":
                TweenMax.set($t,{
                    "x":-inc,
                    "y":inc,
                    "opacity":op,
                });
                break;
            default :
                TweenMax.set($t,{
                    "x":-inc,
                    "opacity":op,
                });
                break;
        }
    }
    render(scrollInc){

    }
    resize(display){

    }
}